import { ProductsElement, type TProductsElement } from '@shared/dream-components';
import type { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import Text from '~/components/Text';
import useIsMobile from '~/hooks/useIsMobile';

interface Props {
  node: TProductsElement;
  children: ReactNode | ReactNode[];
}

const ErrorBoundaryFallback = ({ message }: { message: string }) => (
  <div className="flex max-w-2xl flex-col space-y-2 py-8">
    <Text as="p" type="body" size="md" className="text-center leading-tight tracking-normal">
      {message}
    </Text>
  </div>
);

const ProductsBase = ({ node, children }: Props) => {
  const isViewportMobile = useIsMobile();

  return (
    <ProductsElement isLive element={node} viewport={isViewportMobile ? 'mobile' : 'desktop'}>
      {children}
    </ProductsElement>
  );
};

const Products = ({ node, children }: Props) => {
  return (
    <ErrorBoundary fallbackRender={(props) => <ErrorBoundaryFallback message={props.error.message} />}>
      <ProductsBase node={node}>{children}</ProductsBase>
    </ErrorBoundary>
  );
};

export default Products;
